import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface CommissionerWorkingHours {
    id: string;
    commissioner_id: string;
    weekday: string;
    start_time: string;
    end_time: string;
    open: boolean;
    created_at: string;
    updated_at: string;
}

export interface CommissionerSpecialHour {
    id: string;
    commissioner_id: string;
    name: string;
    date: string;
    start_time: string;
    end_time: string;
    open: boolean;
    created_at: string;
    updated_at: string;
}

export interface WorkingHours {
    weekday: string,
    start_time: string,
    end_time: string,
    open: boolean,
}

export function createWorkingHoursFormGroup(workingHours?: WorkingHours) {
    return new FormGroup({
        weekday: new FormControl<string>(workingHours?.weekday ?? '', [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(9),
            Validators.pattern(/^(monday|tuesday|wednesday|thursday|friday|saturday|sunday)$/i)
        ]),
        start_time: new FormControl<string>(workingHours?.start_time ?? '', [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5)
        ]),
        end_time: new FormControl<string>(workingHours?.end_time ?? '', [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5)
        ]),
        open: new FormControl<boolean>(workingHours?.open ?? false, [
            Validators.required
        ])
    });
}

export function createSpecialHoursFormGroup(specialHour?: CommissionerSpecialHour) {
    return new FormGroup({
        id: new FormControl<string>(specialHour?.id ?? ''),
        name: new FormControl<string>(specialHour?.name ?? '', [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(255)
        ]),
        date: new FormControl<string>(specialHour?.date ?? '', [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10)
        ]),
        start_time: new FormControl<string>(specialHour?.start_time ?? '', [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5)
        ]),
        end_time: new FormControl<string>(specialHour?.end_time ?? '', [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5)
        ]),
        open: new FormControl<boolean>(specialHour?.open ?? false, [
            Validators.required
        ])
    });

}
